/**
 * Every brand value the application chrome needs, in one place.
 *
 * The upstream platform had the same colour written in four files and the same
 * word in three, which made rebranding a search-and-replace exercise. Changing
 * the brand here is editing this file and the `--color-brand-*` ramp in
 * `styles.css`, and nothing else. See ADR 006.
 *
 * This is the *application chrome*. The trading name printed on documents that
 * reach a customer is `Setting.businessName`, which the office edits without a
 * deploy. The two are allowed to differ.
 */

export const BRAND = {
  /** Shown in the app shell, the login screen and the document title. */
  name: 'Bug Busters',

  /** Long form, for the PWA manifest and the install prompt. */
  fullName: 'Bug Busters Pest Control',

  /**
   * The supplied artwork, from the client's brand guide (ADR 024). Drawn only
   * by `components/Wordmark.tsx`. The guide forbids re-typing the wordmark in
   * a font, recolouring or rearranging it, so the name is never set beside
   * the emblem as text — a lockup is the artwork. Reversed is for navy and
   * dark backgrounds. The horizontal lockup drops its tagline below 200px
   * wide (`compact`), and is never drawn under 120px.
   */
  artwork: {
    emblem: '/brand/bugbusters-emblem.svg',
    emblemReversed: '/brand/bugbusters-emblem-reversed.svg',
    horizontal: '/brand/bugbusters-horizontal.svg',
    horizontalReversed: '/brand/bugbusters-horizontal-reversed.svg',
    compact: '/brand/bugbusters-horizontal-compact.svg',
    compactReversed: '/brand/bugbusters-horizontal-compact-reversed.svg',
  },
} as const
